import React, { useRef } from 'react'
import { Card, Space, Statistic, Row, Col } from 'antd'
import { Bar } from 'react-chartjs-2'
import PageLayout from '@layouts/PageLayout'
import Fetch from '@components/CRUD/Fetch'
import { client } from '@utils/client'

const options = {
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
        },
      },
    ],
  },
}

const getBackgroundColor = (number) => {
  const bgColor = [
    'rgba(255, 99, 132, 0.2)',
    'rgba(54, 162, 235, 0.2)',
    'rgba(255, 206, 86, 0.2)',
    'rgba(75, 192, 192, 0.2)',
    'rgba(153, 102, 255, 0.2)',
    'rgba(255, 159, 64, 0.2)',
  ]
  const colors = []
  for (let i = 0; i < number; i++) {
    colors[i] = bgColor[i % 6]
  }
  return colors
}
const getBorderColor = (number) => {
  const borderColor = [
    'rgba(255, 99, 132, 1)',
    'rgba(54, 162, 235, 1)',
    'rgba(255, 206, 86, 1)',
    'rgba(75, 192, 192, 1)',
    'rgba(153, 102, 255, 1)',
    'rgba(255, 159, 64, 1)',
  ]
  const colors = []
  for (let i = 0; i < number; i++) {
    colors[i] = borderColor[i % 6]
  }
  return colors
}

const Dashboard = () => {
  const fetchRef = useRef(null)

  const fetch = async () => {
    const result = await client
      .get('/admin/statistic/users')
      .then((res) => res.data)
    const labels = Object.keys(result.countByAge)
    const data = {
      labels,
      datasets: [
        {
          label: 'จำนวนคนแต่ละอายุ',
          data: Object.values(result.countByAge),
          backgroundColor: getBackgroundColor(labels.length),
          borderColor: getBorderColor(labels.length),
          borderWidth: 1,
        },
      ],
    }
    return {
      all: result.all,
      male: result.male,
      female: result.female,
      children: result.children,
      data,
    }
  }
  return (
    <Fetch fetch={fetch} ref={fetchRef}>
      {({ all, male, female, children, data }) => (
        <PageLayout title="Dashboard" shownBack={false}>
          <Space>
            <Card style={{ width: 300 }}>
              <Statistic title="Active Users" value={all} />
            </Card>
            <Card style={{ width: 300 }}>
              <Row gutter={16}>
                <Col span={12}>
                  <Statistic title="Male" value={male} />
                </Col>
                <Col span={12}>
                  <Statistic title="Female" value={female} />
                </Col>
              </Row>
            </Card>
            <Card style={{ width: 300 }}>
              <Statistic title="Children" value={children} />
            </Card>
          </Space>
          <Bar data={data} options={options} />
        </PageLayout>
      )}
    </Fetch>
  )
}

export default Dashboard
